import Title from './title/slide/slide.jsx'
import LessonOverview from './lesson-overview/slide/slide.jsx'
import Blank from './blank/slide/slide.jsx'
import Text from './text/slide/slide.jsx'
import LearningObjective from './learning-objective/slide/slide.jsx'
import Link from './link/slide/slide.jsx'
import Exercise from './exercise/slide/slide.jsx'
import Image from './image/slide/slide.jsx'
import SuccessCriteria from './success-criteria/slide/slide.jsx'
import Exemplar from './exemplar/slide/slide.jsx'
import Resource from './resource/slide/slide.jsx'
import Video from './video/slide/slide.jsx'
import WordBank from './word-bank/slide/slide.jsx'

const slideTypes = {
  Title,
  LessonOverview,
  Blank,
  Text,
  LearningObjective,
  Link,
  Exercise,
  Image,
  SuccessCriteria,
  Exemplar,
  Resource,
  Video,
  WordBank
}

export default slideTypes
